module.exports = __webpack_public_path__ + "static/media/intellijidea.f37feac6.svg";